// extracted by mini-css-extract-plugin
module.exports =  {"row":"history-module_row__gfvCecSV5dA0KPZL3rRy","whoColumn":"history-module_whoColumn__fGPlWjTj0AE3yuunDnif","container":"history-module_container__gNaZ99DNRNfPzTmbVA6y"};